import engineIsDeno from './engine-is-deno.mjs';
import engineIsNode from './engine-is-node.mjs';

var IS_DENO = engineIsDeno;
var IS_NODE = engineIsNode;

var engineIsBrowser = !IS_DENO && !IS_NODE
  && typeof window == 'object'
  && typeof document == 'object';

export { engineIsBrowser as default };
